import React, { Component } from "react";

const StreetViewImage = () => <div>streetview image</div>;

export default class WarmUpSuit extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="qs-b" ref="warmupsuit">
				<div className="container block-wrap behind-mnt1">
					<div className="d-flex flex-row">
						<div className="col content dark">
							<div className="section-title">
								<h1 className="title">One-Piece Warm Up Suit</h1>
							</div>

							<p className="lead">
								The Qwixskinz One-Piece Warm Up Suit is exactly what our teams
								have been asking for.
							</p>
							<p>
								Improving on the concept of the warm up suit used for years in
								Bobsleigh & Skeleton, we took the opportunity to improve the
								garment in all aspects.
							</p>
							<p>
								Our 4 way stretch fabric allows for a full range of motion with
								no limitations to your movements. The warm up suit fabric is
								fleece backed for warmth & a fabric surface treatment helps with
								dirt & moisture resistance. The perfect fabric weight for
								outdoor warm ups.
							</p>
							<p>
								Elastic drawstring waist lets you get a perfect fit. Calf
								zippers for easy removal while wearing spikes. Currently
								available in Black. Customizing with names & sponsor logos
								available at an additional charge.
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
